import { isWeb } from '../../../../shared/utils/is';
import { MediaFieldFormSubmission } from '../models';

export const MobileDocumentField = MediaFieldFormSubmission.extend({
    defaults: $.extend({}, MediaFieldFormSubmission.prototype.defaults, {
        metadata: $.extend({}, MediaFieldFormSubmission.prototype.defaults.metadata, {
            file_metadata: [
                {
                    id: null,
                    original_name: null,
                    size: null,
                    file_id: null
                }
            ]
        })
    }),

    initialize: function (attributes, options) {
        var this_ = this;
        options = options || {};
        $.extend(this, options);

        MobileDocumentField.__super__.initialize.apply(this, arguments);

        this.on('change:file', function () {
            // @author:halah when we process native files, we override raw_file .Since raw file for cordova
            // doesn't have name & size or metadata, I add the values to the file metadata & do this check.
            var files = this_.get('file');
            if (!files || !files.length) {
                this.update_metadata({ file_metadata: null });
                return;
            }
            this_.update_metadata({
                file_metadata: this._format_file_metadata(files)
            });
        });
    },

    get_display_name: function (file_id) {
        var this_ = this;
        var metadata = this.get('metadata');

        if (!metadata || !metadata.file_metadata || !metadata.file_metadata.length) {
            return '';
        }
        var index = this_._get_file_index_of_current_doc(file_id);
        return metadata.file_metadata[index].original_name;
    },

    get_display_size: function (file_id) {
        var this_ = this;
        var metadata = this.get('metadata');

        if (!metadata || !metadata.file_metadata || !metadata.file_metadata.length) {
            return '';
        }
        var index = this_._get_file_index_of_current_doc(file_id);
        return $f.utils.format_bytes(metadata.file_metadata[index].size);
    },

    get_url: function (file_id) {
        var this_ = this;
        var url = '#';
        var index = this_._get_file_index_of_current_doc(file_id);
        if (this.get('value') && !this.get('file')) {
            url = $f.storage.get_storage_full_url(this.get('value')[index]);
        }
        return url;
    },

    _get_file_index_of_current_doc: function (file_id) {
        var metadata = this.get('metadata');

        var index = metadata.file_metadata
            .map(function (file) {
                return file.file_id;
            })
            .indexOf(file_id);
        if (index == -1) {
            index = 0;
        }
        return index;
    },

    _format_file_metadata: function (current_files) {
        return current_files.map(function (file) {
            var original_name = isWeb() ? file.get('raw_file').name : file.get('metadata').name;
            var size = isWeb() ? file.get('raw_file').size : file.get('metadata').size;
            return {
                id: file.get('url_s3'),
                original_name: original_name,
                size: size,
                file_id: file.get('id')
            };
        });
    },

    get_submission_value: function () {
        const file_metadatas = this.get_metadata_attribute('file_metadata') || [];
        const file_s3_values = this.get('value') || [];

        if (file_metadatas.length === 0) {
            return file_s3_values.map((s3_key) => ({ s3_key }));
        }

        return this._map_values_with_metadatas(file_s3_values, file_metadatas);
    },

    _map_values_with_metadatas: function (file_s3_values, file_metadatas) {
        return file_s3_values.map((s3_key, idx) => {
            const { original_name, size } = file_metadatas[idx];

            return { s3_key, original_name, size };
        });
    }
});
